module.exports = __webpack_public_path__ + "img/lzgz.1d313af7.png";